/*
 * Inventory Status Filter Util
 * pure helpers that decide which table filter drives the Status dropdown
 * on the manage inventory / All Assets screen
 */
import { inventoryStatusFilterEnum, jobTypesIdEnum } from '../../models-enums';

export type InventoryStatusFilterKey =
    | 'workOrderResultStatus'
    | 'measurementPointListResultStatus'
    | 'originalMeasurementPointListResultStatus';

/*
 * In add-work-order mode (All Assets) the table shows the status the asset had
 * before this job (originalMeasurementPointListResultStatus), so the Status
 * dropdown must filter on that same field
 */
export const getStatusFilterKey = (
    isAddWorkOrderMode: boolean,
    isWorkOrderTypeJob: boolean,
    jobTypeID: string
): InventoryStatusFilterKey => {
    if (isWorkOrderTypeJob && jobTypeID !== jobTypesIdEnum.commissioning) {
        return isAddWorkOrderMode ? 'originalMeasurementPointListResultStatus' : 'workOrderResultStatus';
    }
    return 'measurementPointListResultStatus';
};

export const shouldShowStatusFilter = (
    isAddWorkOrderMode: boolean,
    isWorkOrderTypeJob: boolean,
    jobTypeID: string
): boolean => {
    if (!isAddWorkOrderMode) {
        return true;
    }
    return isWorkOrderTypeJob && jobTypeID !== jobTypesIdEnum.commissioning;
};

/*
 * Sort order for measurement point status options: Pass, Fail, Not Tested, then others
 */
export const getStatusOrder = (statusValue: string | number): number => {
    const value = typeof statusValue === 'number' ? statusValue : parseInt(statusValue, 10);
    if (value === inventoryStatusFilterEnum.resultStatusPass) return 1;
    if (value === inventoryStatusFilterEnum.resultStatusFail) return 2;
    if (value === inventoryStatusFilterEnum.resultStatusNotTested) return 3;
    return 4;
};
